// ==============================|| THEME CONSTANT ||============================== //
// const role = sessionStorage.getItem('role')

const mainUser = JSON.parse(sessionStorage.getItem("main-user"));
const roleName =
    mainUser?.user?.roleId?.name ??
    mainUser?.roleId?.name;

const role = roleName?.toLowerCase();

export const APP_DEFAULT_PATH = `/${role}/dashboard`;
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;
